(function ($) {
    var divEvitement = $("#evitement");

    divEvitement.find("a").on("focus", function () {
        divEvitement.addClass("show-evitement");
    }).on("blur", function () {
        divEvitement.removeClass("show-evitement");
    });
})(jQuery);